import { germinatedSeedBagGetAll, germinatedSeedBagGetAllForDropdown } from "@/api/germinated_seed_bag";

const state = {
    germinatedSeedBag: null,
    germinatedSeedBagDetail: null,
    germinatedSeedBagOptions: null
};

const mutations = {
    GET_ALL: (state, data) => {
        state.germinatedSeedBag = data;
    },
    GET_DETAIL: (state, data) => {
        state.germinatedSeedBagDetail = data;
    },
    GET_OPTIONS: (state, data) => {
        state.germinatedSeedBagOptions = data;
    },
};

const actions = {
    async germinatedSeedBagGetAll({ commit }, notificationPagination) {
        let res = await germinatedSeedBagGetAll({ ...notificationPagination });
        if (res) {
            commit("GET_ALL", res); 
        }
    },
    async getAllGerminatedSeedBagOptions({ commit }, notificationPagination) {
        let res = await germinatedSeedBagGetAllForDropdown({ ...notificationPagination });
        if (res) {
            commit("GET_OPTIONS", res); 
        }
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};




// WEBPACK FOOTER //
// ./src/vuex/modules/germinated_seed_bag.js